var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

// THIS IS A GENERATED FILE. DO NOT MODIFY MANUALLY. @see scripts/compile-icons.js

import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var EuiIconEyeClosed = function EuiIconEyeClosed(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? ___EmotionJSX("title", {
    id: titleId
  }, title) : null, ___EmotionJSX("path", {
    fillRule: "evenodd",
    d: "M4.925 13.197C5.841 13.675 6.875 14 8 14c2.407 0 4.402-1.488 5.707-2.793a16.045 16.045 0 0 0 2.105-2.62l.032-.05.009-.015.003-.005v-.001S15.858 8.514 15 8l.857.514a1 1 0 0 0 0-1.028l-.001-.003-.003-.005-.01-.015a5.978 5.978 0 0 0-.144-.227 16.042 16.042 0 0 0-2.183-2.63l-.707.707A14.611 14.611 0 0 1 14.999 8s-3 5-7 5c-.824 0-1.606-.212-2.328-.55l-.746.747ZM15 8l.857-.514L15 8Z",
    clipRule: "evenodd"
  }), ___EmotionJSX("path", {
    d: "m6.262 10.445-1.5 1.5-.721.722-2.687 2.687-.707-.707 14-14 .707.707-2.586 2.585-.71.71s0 .001 0 0l-1.613 1.613-.722.722-2.739 2.74-.722.721Zm.961.454a3 3 0 0 0 3.675-3.675l-.902.902a2 2 0 0 1-1.87 1.87l-.903.902Z"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    d: "M11.075 2.804C10.16 2.324 9.125 2 8 2 5.593 2 3.598 3.488 2.293 4.793a16.039 16.039 0 0 0-2.106 2.62 5.95 5.95 0 0 0-.031.05l-.01.015-.002.005v.001c-.001 0-.002.002.856.516l-.858-.514c-.19.316-.19.712 0 1.03l.002.001.003.005.009.015a6.117 6.117 0 0 0 .145.227 16.042 16.042 0 0 0 2.183 2.63l.707-.706C1.827 9.378 1 8 1 8s3-5 7-5c.825 0 1.607.213 2.329.55l.746-.746ZM.143 8.515 1 8c-.858.514-.857.515-.857.515Z",
    clipRule: "evenodd"
  }), ___EmotionJSX("path", {
    d: "M8.777 5.102a3.004 3.004 0 0 0-3.675 3.675l.902-.902a2 2 0 0 1 1.871-1.871l.902-.902Z"
  }));
};
export var icon = EuiIconEyeClosed;